// Screen `template-variants` (owner: doc-variants, owner feedback F12): the records that have their own
// version of one PDF template, what they changed and what the newest template version means for each.
import { createFileRoute } from '@tanstack/react-router';
import { TemplateVariants } from '../../../../features/doc-variants/TemplateVariants';

export const Route = createFileRoute('/_app/documents/variants/$templateId')({
  component: TemplateVariantsRoute,
});

function TemplateVariantsRoute() {
  const { templateId } = Route.useParams();
  return <TemplateVariants key={templateId} templateId={templateId} />;
}
